import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler
} from 'chart.js';
import { Line, Doughnut } from 'react-chartjs-2';
import '../styles/Reports.css';

// Register ChartJS elements
ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, 
  Title, Tooltip, Legend, ArcElement, Filler
);

const Reports = () => {
  // Line Chart Data (Sales Overview)
  const lineChartData = {
    labels: ['01 May', '04 May', '07 May', '10 May', '13 May', '16 May', '20 May'],
    datasets: [
      {
        fill: true,
        data: [15000, 25000, 45000, 30000, 60000, 60000, 70000, 45000, 65000, 70000, 100000, 85000, 115000],
        borderColor: '#1d4ed8', // Blue line
        backgroundColor: 'rgba(29, 78, 216, 0.1)', // Light blue fade
        borderWidth: 2,
        pointBackgroundColor: '#1d4ed8',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 4,
        tension: 0.4, // Smooth curves
      },
    ],
  };

  const lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false }, ticks: { color: '#848a95', font: { size: 11 } } },
      y: { 
        grid: { color: '#f4f5f8' }, 
        ticks: { 
          color: '#848a95', font: { size: 11 },
          callback: (value) => value === 0 ? '₹0' : `₹${value / 1000},000`
        },
        min: 0,
        max: 120000,
      },
    },
  };

  // Doughnut Chart Data (Sales by Category)
  const doughnutData = {
    labels: ['Plants & Seeds', 'Fertilizers', 'Pots & Trays', 'Garden Tools', 'Others'],
    datasets: [{
      data: [320450, 245230, 135640, 95200, 78910],
      backgroundColor: ['#3b82f6', '#22c55e', '#8b5cf6', '#f59e0b', '#848a95'],
      borderWidth: 0,
      cutout: '65%',
    }],
  };

  const tableData = [
    { date: "20 May 2025", inv: 24, sales: "₹78,450", disc: "₹2,450", tax: "₹11,870", net: "₹87,870", rcvd: "₹85,400", ret: "₹2,470", rec: "₹0" },
    { date: "19 May 2025", inv: 22, sales: "₹65,230", disc: "₹1,920", tax: "₹9,850", net: "₹73,160", rcvd: "₹68,160", ret: "₹1,730", rec: "₹5,000" },
    { date: "18 May 2025", inv: 20, sales: "₹58,760", disc: "₹1,650", tax: "₹8,520", net: "₹65,630", rcvd: "₹65,630", ret: "₹0", rec: "₹0" },
    { date: "17 May 2025", inv: 18, sales: "₹52,340", disc: "₹1,230", tax: "₹7,590", net: "₹58,700", rcvd: "₹53,700", ret: "₹0", rec: "₹5,000" },
    { date: "16 May 2025", inv: 21, sales: "₹63,890", disc: "₹1,880", tax: "₹9,420", net: "₹71,430", rcvd: "₹66,430", ret: "₹0", rec: "₹5,000" }
  ];

  const topProducts = [
    { id: 1, name: "Coco Peat Block - 5kg", qty: 320, sales: "₹64,000" },
    { id: 2, name: "Vermicompost 1kg", qty: 280, sales: "₹42,000" },
    { id: 3, name: "Organic Fertilizer 1kg", qty: 210, sales: "₹31,500" },
    { id: 4, name: "Grow Bags (12x12)", qty: 190, sales: "₹28,500" },
    { id: 5, name: "Neem Oil 250ml", qty: 160, sales: "₹19,200" }
  ];

  return (
    <div className="rep-dashboard-wrapper">
      
      {/* Top Filters */}
      <div className="rep-filters-bar">
        <div className="rep-filter-dropdown rep-date-picker">
          <i className="fa-regular fa-calendar"></i> 01 May 2025 - 20 May 2025 <i className="fa-solid fa-chevron-down rep-arrow"></i>
        </div>
        <div className="rep-filter-dropdown">All Branches <i className="fa-solid fa-chevron-down rep-arrow"></i></div>
        <div className="rep-filter-dropdown">All Categories <i className="fa-solid fa-chevron-down rep-arrow"></i></div>
        <div className="rep-filter-dropdown">All Users <i className="fa-solid fa-chevron-down rep-arrow"></i></div>
        <div className="rep-actions">
          <button className="rep-btn-primary"><i className="fa-solid fa-filter"></i> Filters</button>
          <button className="rep-btn-outline"><i className="fa-solid fa-download"></i> Export</button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="rep-kpi-grid">
        <div className="rep-card rep-kpi-card">
          <div className="rep-icon-box rep-bg-blue-light"><i className="fa-solid fa-coins rep-text-blue"></i></div>
          <div className="rep-kpi-info">
            <span className="rep-label">Total Sales</span>
            <h2 className="rep-value">₹8,75,430</h2>
            <div className="rep-trend rep-text-green"><i className="fa-solid fa-arrow-up"></i> 18.6% vs Last Month</div>
          </div>
        </div>
        <div className="rep-card rep-kpi-card">
          <div className="rep-icon-box rep-bg-green-light"><i className="fa-solid fa-cart-shopping rep-text-green"></i></div>
          <div className="rep-kpi-info">
            <span className="rep-label">Total Purchases</span>
            <h2 className="rep-value">₹5,45,230</h2>
            <div className="rep-trend rep-text-green"><i className="fa-solid fa-arrow-up"></i> 12.4% vs Last Month</div>
          </div>
        </div>
        <div className="rep-card rep-kpi-card">
          <div className="rep-icon-box rep-bg-orange-light"><i className="fa-solid fa-indian-rupee-sign rep-text-orange"></i></div>
          <div className="rep-kpi-info">
            <span className="rep-label">Gross Profit</span>
            <h2 className="rep-value">₹3,30,200</h2>
            <div className="rep-trend rep-text-green"><i className="fa-solid fa-arrow-up"></i> 22.7% vs Last Month</div>
          </div>
        </div>
        <div className="rep-card rep-kpi-card">
          <div className="rep-icon-box rep-bg-purple-light"><i className="fa-solid fa-wallet rep-text-purple"></i></div>
          <div className="rep-kpi-info">
            <span className="rep-label">Total Expenses</span>
            <h2 className="rep-value">₹3,25,120</h2>
            <div className="rep-trend rep-text-red"><i className="fa-solid fa-arrow-down"></i> 5.3% vs Last Month</div>
          </div>
        </div>
        <div className="rep-card rep-kpi-card">
          <div className="rep-icon-box rep-bg-teal-light"><i className="fa-solid fa-chart-line rep-text-teal"></i></div>
          <div className="rep-kpi-info">
            <span className="rep-label">Net Profit</span>
            <h2 className="rep-value">₹1,05,080</h2>
            <div className="rep-trend rep-text-green"><i className="fa-solid fa-arrow-up"></i> 35.8% vs Last Month</div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="rep-tabs">
        <div className="rep-tab active">Sales Report</div>
        <div className="rep-tab">Purchase Report</div>
        <div className="rep-tab">Profit & Loss</div>
        <div className="rep-tab">Stock Report</div>
        <div className="rep-tab">GST Report</div>
        <div className="rep-tab">Customer Report</div>
        <div className="rep-tab">Supplier Report</div>
        <div className="rep-tab">Expense Report</div>
      </div>

      {/* Middle Row: Charts & Top Products */}
      <div className="rep-charts-grid">
        
        {/* Sales Overview Line Chart */}
        <div className="rep-card rep-chart-card rep-span-2">
          <div className="rep-card-header">
            <h3>Sales Overview</h3>
            <div className="rep-small-dropdown">This Month <i className="fa-solid fa-chevron-down"></i></div>
          </div>
          <div className="rep-chart-metrics">
            <div className="rep-cm-icon"><i className="fa-solid fa-arrow-up-right-dots"></i></div>
            <div className="rep-cm-data">
              <span className="rep-cm-label">Total Sales <span className="rep-badge-green"><i className="fa-solid fa-arrow-up"></i> 18.6%</span></span>
              <h2 className="rep-cm-value">₹8,75,430 <span className="rep-cm-sub">vs 01 Apr 2025 - 30 Apr 2025</span></h2>
            </div>
          </div>
          <div className="rep-line-chart-container">
            <Line data={lineChartData} options={lineChartOptions} />
          </div>
        </div>

        {/* Sales by Category Doughnut Chart */}
        <div className="rep-card rep-chart-card">
          <div className="rep-card-header">
            <h3>Sales by Category</h3>
            <div className="rep-small-dropdown">This Month <i className="fa-solid fa-chevron-down"></i></div>
          </div>
          <div className="rep-donut-layout">
            <div className="rep-donut-container">
              <Doughnut data={doughnutData} options={{ plugins: { legend: { display: false } }, cutout: '70%' }} />
              <div className="rep-donut-center">
                <span className="rep-dc-label">Total</span>
                <span className="rep-dc-value">₹8,75,430</span>
              </div>
            </div>
            <div className="rep-donut-legend">
              <div className="rep-leg-item"><span className="rep-dot bg-blue"></span><div><strong>Plants & Seeds</strong><br/><span>₹3,20,450 (36.6%)</span></div></div>
              <div className="rep-leg-item"><span className="rep-dot bg-green"></span><div><strong>Fertilizers</strong><br/><span>₹2,45,230 (28.0%)</span></div></div>
              <div className="rep-leg-item"><span className="rep-dot bg-purple"></span><div><strong>Pots & Trays</strong><br/><span>₹1,35,640 (15.5%)</span></div></div>
              <div className="rep-leg-item"><span className="rep-dot bg-orange"></span><div><strong>Garden Tools</strong><br/><span>₹95,200 (10.9%)</span></div></div>
              <div className="rep-leg-item"><span className="rep-dot bg-gray"></span><div><strong>Others</strong><br/><span>₹78,910 (9.0%)</span></div></div>
            </div>
          </div>
        </div>

        {/* Top Selling Products */}
        <div className="rep-card rep-chart-card">
          <div className="rep-card-header">
            <h3>Top Selling Products</h3>
            <div className="rep-small-dropdown">This Month <i className="fa-solid fa-chevron-down"></i></div>
          </div>
          <table className="rep-mini-table">
            <thead>
              <tr><th>#</th><th>Product</th><th>Qty Sold</th><th>Sales</th></tr>
            </thead>
            <tbody>
              {topProducts.map(p => (
                <tr key={p.id}>
                  <td className="rep-text-muted">{p.id}</td>
                  <td><div className="rep-prod-cell"><div className="rep-img-placeholder"></div> {p.name}</div></td>
                  <td>{p.qty}</td>
                  <td><strong>{p.sales}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="rep-card-footer">
            <a href="#" className="rep-link">View all products report <i className="fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
      </div>

      {/* Bottom Row: Table & Shortcuts */}
      <div className="rep-bottom-grid">
        
        {/* Main Data Table */}
        <div className="rep-card rep-table-card">
          <div className="rep-card-header">
            <h3>Sales Summary</h3>
            <div className="rep-actions-sm">
              <div className="rep-small-dropdown">Daily <i className="fa-solid fa-chevron-down"></i></div>
              <button className="rep-btn-outline-sm"><i className="fa-solid fa-download"></i> Download</button>
            </div>
          </div>
          <div className="rep-table-responsive">
            <table className="rep-data-table">
              <thead>
                <tr>
                  <th>Date</th><th>Invoices</th><th>Total Sales</th><th>Discount</th>
                  <th>Tax (GST)</th><th>Net Sales</th><th>Payments Received</th>
                  <th>Returns</th><th>Net Receivable</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, i) => (
                  <tr key={i}>
                    <td className="rep-fw-500">{row.date}</td>
                    <td>{row.inv}</td>
                    <td>{row.sales}</td>
                    <td>{row.disc}</td>
                    <td>{row.tax}</td>
                    <td className="rep-fw-600">{row.net}</td>
                    <td>{row.rcvd}</td>
                    <td>{row.ret}</td>
                    <td className="rep-fw-600">{row.rec}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>Total</td><td>105</td><td>₹3,18,670</td><td>₹9,130</td>
                  <td>₹47,250</td><td>₹3,56,790</td><td>₹3,39,320</td>
                  <td>₹4,200</td><td>₹17,470</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Shortcuts List */}
        <div className="rep-card rep-shortcuts-card">
          <h3 className="rep-shortcuts-title">Reports Shortcuts</h3>
          <div className="rep-shortcut-list">
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-blue-light"><i className="fa-solid fa-chart-column rep-text-blue"></i></div>
              <div className="rep-sh-text"><strong>Sales Report</strong><span>Detailed sales analysis</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-green-light"><i className="fa-solid fa-cart-shopping rep-text-green"></i></div>
              <div className="rep-sh-text"><strong>Purchase Report</strong><span>Detailed purchase analysis</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-orange-light"><i className="fa-solid fa-chart-pie rep-text-orange"></i></div>
              <div className="rep-sh-text"><strong>Profit & Loss Report</strong><span>Business profitability report</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-blue-light"><i className="fa-solid fa-box rep-text-blue"></i></div>
              <div className="rep-sh-text"><strong>Stock Report</strong><span>Stock status and valuation</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-teal-light"><i className="fa-solid fa-file-invoice rep-text-teal"></i></div>
              <div className="rep-sh-text"><strong>GST Report</strong><span>GST collected and paid report</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-green-light"><i className="fa-solid fa-users rep-text-green"></i></div>
              <div className="rep-sh-text"><strong>Customer Report</strong><span>Customer-wise sales report</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
            <div className="rep-shortcut-item">
              <div className="rep-icon-sm rep-bg-purple-light"><i className="fa-solid fa-truck rep-text-purple"></i></div>
              <div className="rep-sh-text"><strong>Supplier Report</strong><span>Supplier-wise purchase report</span></div>
              <i className="fa-solid fa-chevron-right rep-text-muted"></i>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Reports;